<template>
    <div class="container">
        <div class="text-start mt-3 mb-3 ms-5">
            <h3>Guía de Referencia Política de Crédito</h3>
        </div>
        <div id="guia" class="container">
            <div id="cabeceraGR" class="row bg-info">
                <div class="col-sm-12 col-md-12 col-lg-7">
                    <nav>
                        <div class="nav nav-tabs ms-5 pt-3" id="nav-tab" role="tablist">
                            <button :class="`nav-link me-3 ${this.estaActivoC}`" id="nav-credito-tab" @click="seleccion('c')">Crédito</button>
                            <button :class="`nav-link me-3 ${this.estaActivoE}`" id="nav-escrituracion-tab" @click="seleccion('e')">Escrituración</button>
                            <button :class="`nav-link ${this.estaActivoCE}`" id="nav-cye-tab" @click="seleccion('ce')">Crédito y Escrituración</button>
                        </div>
                    </nav>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-3 offset-lg-2">
                    <input id="busquedaGuia" type="text" class="form-control rounded-pill" placeholder="Buscar" v-model="busqueda" v-on:focus="seleccion('b')"/>
                </div>
            </div>
            <div id="textoCabecera" class="mt-4">
                <div v-show="this.estaActivoC == 'active'">
                    <h5 class="mb-4">Análisis de Crédito</h5>
                    <p>
                        El análisis de Crédito se enfoca en tres segmentos relacionados:
                    </p>
                    <ul>
                        <li>El primero es la <b>Comprobación de Ingresos</b> tanto de las Capacidades de Pago como de Endeudamiento;</li>
                        <li>El segundo, se relaciona a la <b>Solvencia Moral</b> evaluando <b>el comportamiento de pagos internos en el Sistema HIR Casa</b> y de las obligaciones con otras Instituciones; y</li>
                        <li>Tercera, la <b>Solvencia Económica</b> que se vincula a la capacidad que el Cliente puede demostrar con su Patrimonio actual (inversiones bancarias, sueldo y bienes).</li>
                    </ul>
                </div>
                <div v-show="this.estaActivoE == 'active'">
                    <h5 class="mb-4">Análisis de Escrituración</h5>
                    <p>
                        El análisis se enfoca, en la <b>Evaluación de la Viabilidad Jurídica</b> de la propiedad que está sujeta a la Compra Venta, construcción o remodelación (libertad de gravámenes o problemas de la propiedad), a la revisión de la <b>Personalidad Jurídica del Cliente</b> (física y/o moral) así como del <b>Vendedor y/o garante hipotecario</b> que está ofreciendo o dejando el inmueble en garantía (Poderes) y la de Asegurar el <b>Respaldo jurídico de la operación</b> (Pagaré, Avalúo).
                    </p>
                </div>
            </div>
            <div id="cajaBotones">
                <div v-show="this.estaActivoC == 'active'">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-3" v-for="boton in informacionFiltrada" :key="boton.id">
                            <div>
                                <button class="btn btn-outline-primary rounded-pill w-100" @click="mostrarInfo(boton.id)">{{boton.titulo}}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="this.estaActivoE == 'active'">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-3" v-for="boton in informacionFiltrada" :key="boton.id">
                            <div>
                                <button class="btn btn-outline-primary rounded-pill w-100" @click="mostrarInfo(boton.id)">{{boton.titulo}}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="this.estaActivoCE == 'active'">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-3" v-for="boton in informacionFiltrada" :key="boton.id">
                            <div>
                                <button class="btn btn-outline-primary rounded-pill w-100" @click="mostrarInfo(boton.id)">{{boton.titulo}}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="this.estaActivoB == 'active'">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-3" v-for="boton in informacionFiltrada" :key="boton.id">
                            <div>
                                <button class="btn btn-outline-primary rounded-pill w-100" @click="mostrarInfo(boton.id)">{{boton.titulo}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="contenido">
                <div class="row mt-5">
                    <div class="ps-5 pe-5 text-start">
                        <h5 class="mb-4">{{this.titulo}}</h5>
                        <div v-for="linea in this.mensaje" :key="linea">
                            <p>{{ linea }}</p>
                        </div>
                    </div>
                </div>
                <div id="imagenGR" class="row" v-show="this.src != ''">
                    <div class="text-center mb-5">
                        <img :src="src" class="imgGR">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'CajaBotones',

    props: {
        informacion: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            busqueda: '',
            seccion: 'c',
            seleccionadoE: true,
            subrayadoE: 'text-decoration-underline',
            mostrarRetorno: true,
            titulo: '',
            mensaje: '',
            src: '',
            //src: '/img/imagenPrototipo.png',
            estaActivoC: 'active',
            estaActivoE: '',
            estaActivoCE: '',
            estaActivoB: '',
        }
    },

    computed: {
        informacionFiltrada() {
            if (this.seccion == 'c') {
                return this.informacion
                    .filter(b =>
                        b.area == 'credito'
                )
            }
            if (this.seccion == 'e') {
                return this.informacion
                    .filter(b =>
                        b.area == 'escrituracion'
                )
            }
            if (this.seccion == 'ce') {
                return this.informacion
                    .filter(b =>
                        b.area == 'ambas'
                )
            }
            
            if (!this.busqueda.length) {
                return this.informacion
            }

            return this.informacion
                .filter(b => 
                    //b.mensaje.join().toLowerCase().includes(this.busqueda.toLowerCase()) ||
                    b.mensaje.join(' ').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(this.busqueda.toLowerCase())
                )
        }
    },

    methods: {
        seleccion(valor) {
            this.titulo = ''
            this.mensaje = ''
            this.src = ''
            if(valor == 'c') {
                this.seccion = 'c'
                this.estaActivoC = 'active'
                this.estaActivoE = ''
                this.estaActivoCE = ''
                this.estaActivoB = ''
            }
            if(valor == 'e') {
                this.seccion = 'e'
                this.estaActivoC = ''
                this.estaActivoE = 'active'
                this.estaActivoCE = ''
                this.estaActivoB = ''
            }
            if(valor == 'ce') {
                this.seccion = 'ce'
                this.estaActivoC = ''
                this.estaActivoE = ''
                this.estaActivoCE = 'active'
                this.estaActivoB = ''
            }
            if(valor == 'b') {
                this.seccion = 'b'
                this.estaActivoC = ''
                this.estaActivoE = ''
                this.estaActivoCE = ''
                this.estaActivoB = 'active'
            }
        },
        
        mostrarInfo(id) {
            let info = this.informacion.find(e => e.id == id)
            this.titulo = info.titulo
            this.mensaje = info.mensaje
            this.src = info.src
        }
    }
})
</script>

<style scoped>
    #guia {
        min-height: 600px;
        border-radius: 15px;
        box-shadow: 5px 5px 15px 2px #b2b2b2;
    }

    .btn {
        font-family: Montserrat;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        line-height: 15px;
        /*width: 230px;*/
        height: 60px;
        margin-top: 20px;
    }

    .nav-link {
        border-top-left-radius: 15px !important;
        border-top-right-radius: 15px !important;
        font-family: Montserrat;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 17px;
        color: snow;
    }

    .nav-link:hover {
        color: snow;
    }

    h3 {
        font-family: Montserrat;
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
        line-height: 29px;
    }

    h5 {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 900;
        font-size: 18px;
        line-height: 15px;
        color: #4D4F5C;
    }

    p, li {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #4D4F5C;
        text-align: justify;
    }

    #cabeceraGR {
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        margin-left: -24px;
        margin-right: -24px;
    }
/*
    .imgGR {
        width: 315px;
    }
*/
    #busquedaGuia {
        margin-top: 6px;
        background-image:url('../../../../../../public/icons/search.svg');
        background-size: 20px 20px;
        background-repeat: no-repeat;
        background-position: 10px;
        text-indent: 25px;
        border: solid 2px #FFA000;
    }

    @media (max-width: 1024px) {
        #imagenGR {
            display: none;
        }
    }
</style>
